exports = module.exports = require("../../../build/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".banner-container[data-v-1bb6e51a]{margin:16px 18px}.banner-image[data-v-1bb6e51a]{width:100%;border-radius:6px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-1bb6e51a","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!../src/component/post-activity/index.vue
// module id = 743
// module chunks = 0 2